import PropTypes from 'prop-types';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import styles from './index.scss';
import CardMedia1 from '../Gift_card.png';
import CardMedia2 from './T-Shirt.png';
import CardMedia3 from './Party_Cups.png';
import CardMedia4 from './Props.png';
import IconTransportation from '../icon-transportation.png';
import IconInternet from '../icon-internet.png';
import IconRippleLogin from '../icon-ripple-login.png';
import IconSocialShare from '../icon-social-share.png';
import IconFun from '../icon-fun.png';
import IconSelfiePurple from './icons/selfie-purple.png';
import IconPostOnInstagram from './icons/ig_purple.png';
import IconTakeASurvey from './icons/survey-purple.png';
import IconSurveyRed from './icons/survey-red.png';
import IconShareOnSocial from './icons/social_share-red.png';
import IconTakeSelfie from './icons/selfie-red.png';
import IconPostAPicture from './icons/post_pic-orange.png';
import IconPostOnInstagramOrange from './icons/ig_orange.png';
import IconWriteAreview from './icons/write_reviews-orange.png';

const useStyles = makeStyles((theme) => ({
  cardLg: {
    width: 275,
    height: 275,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '0.5rem 0.5rem rgba(0,0,0,.5)',
    borderRadius: '10px',
    margin: '10px auto',
  },
  cardLgContent: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: '40px!important',
  },
  cardMd: {
    width: 190,
    height: 190,
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '0.5rem 0.5rem rgba(183, 164, 207,.5)',
    borderRadius: '10px',
    margin: '10px auto',
  },
  cardMdContent: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: '40px!important',
  },
  cardMd__ShadowRed: {
    boxShadow: '0.5rem 0.5rem rgba(250, 166, 160,.5)',
  },
  cardMd__ShadowOrange: {
    boxShadow: '0.5rem 0.5rem rgba(250, 193, 191,.5)',
  },
}));

const SvedkaHalloween = ({ navigateToApplication }) => {
  const classes = useStyles();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.inner} />
      </div>
      <div className={styles.applyNow}>
        <p>
          Be the Ghostest with the Mostest when you host a SVEDKA GOES Halloween Party! Show your friends how you like to get the party
          started and have some fun on Halloween by treating them to deliciously sweet, spicy and bloody good SVEDKA cocktails. <br />
          <br />
          <strong>If you are 21+ AND a resident of CA, CO, FL, NY, TX and WA,</strong> apply today if you dare! <span role='img' aria-label='Dare!' style={{ fontSize: 22 }}>🧛</span>
        </p>
        <Button size='small' variant='contained' color='success' className={styles.applyNowBtn} onClick={navigateToApplication}>Event Closed!</Button>
      </div>
      <div className={styles.premiumChatterbox}>
        <h1>If you&#39;re selected and confirmed as a host, your exclusive Party Pack will contain:</h1>

        <Grid container justifyContent='space-between'>
          <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '10% auto',
                    width: '80%',
                  }}
                  src={CardMedia1}
                  alt='$20 GIFT CARD'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              $20 GIFT CARD
            </div>
          </Grid>
          <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '4% auto',
                    width: '80%',
                  }}
                  src={CardMedia2}
                  alt='T-SHIRTS'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              T-SHIRTS
            </div>
          </Grid>
          <Grid key={3} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: '15% auto',
                    width: '100%',
                  }}
                  src={CardMedia3}
                  alt='12 OZ PARTY CUPS'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              12 OZ PARTY CUPS
            </div>
          </Grid>
          <Grid key={4} lg={3} md={4} sm={6} xs={12} item>
            <Card className={classes.cardLg}>
              <CardContent className={classes.cardLgContent}>
                <img
                  style={{
                    display: 'block',
                    margin: 'auto',
                    width: '100%',
                  }}
                  src={CardMedia4}
                  alt='AND MORE'
                />
              </CardContent>
            </Card>
            <div className={styles.cardTitle}>
              AND MORE
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={styles.programSteps}>
        <h1>What We Do and Ask of House Party Hosts</h1>
        <h2>
          We work with great brands like SVEDKA Vodka to give their most passionate fans the chance to try new products at home for free.
          In exchange, our brand partners like seeing you experience their products and hearing about your honest opinions throughout
          the program. That’s why the more activities you do and the higher quality they are, the higher your chances to be selected as a
          host and receive a Party Pack—because brands love active fans and great content.<br /><br />Read on to learn more about your activities for this event!
        </h2>

        <div className={styles.stepsContainer}>
          <div className={styles.thingsYouNeed}>
            <p className={styles.thingsLabel}>
              <CheckCircleIcon
                style={{
                  color: '#006ca4',
                  verticalAlign: 'top',
                  marginRight: '5px',
                }}
              />
              THINGS YOU&#39;LL NEED
            </p>
            <div className={styles.thingsContainer}>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconTransportation} alt='Transportation' />
                </div>
                <p className={styles.thingText}>Transportation</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconInternet} alt='Internet' />
                </div>
                <p className={styles.thingText}>Internet Access</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconRippleLogin} alt='Ripple Street Login' />
                </div>
                <p className={styles.thingText}>Ripple Street Login</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img src={IconSocialShare} alt='Social Account(s)' />
                </div>
                <p className={styles.thingText}>Social Account(s)</p>
              </div>
              <div className={styles.thing}>
                <div className={styles.thingImageContainer}>
                  <img
                    className={styles.funEmoji}
                    src={IconFun}
                    alt='An Enormous Sense of FUN!'
                  />
                </div>
                <p className={styles.thingText}>An Enormous Sense of FUN!</p>
              </div>
            </div>
          </div>
          <div className={styles.steps}>
            <div className={styles.stepsLi}>
              <div className={styles.numberOne}>1</div>
              <p className={styles.stepsText}>
                <span className={styles.stepsHeading}>AFTER YOU APPLY,</span>{' '}
                we&#39;ll ask you and fellow applicants to do the following
                activities for the chance to get selected for this program.
              </p>
            </div>
            <div className={styles.cardMdContainer}>
              <Grid container justifyContent='flex-start'>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card className={classes.cardMd}>
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 25%',
                          width: '50%',
                        }}
                        src={IconSelfiePurple}
                        alt='Take a Selfie'
                      />
                      <p className={styles.cardMdTitle}>
                        Take a Selfie
                      </p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
                  <Card className={classes.cardMd}>
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% auto 10%',
                          width: '50%',
                        }}
                        src={IconPostOnInstagram}
                        alt='Post on Instagram'
                      />
                      <p className={styles.cardMdTitle}>
                        Post on Instagram
                      </p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={3} lg={3} md={4} sm={6} xs={12} item>
                  <Card className={classes.cardMd}>
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={IconTakeASurvey}
                        alt='Take a Survey'
                      />
                      <p className={styles.cardMdTitle}>Take a Survey</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
            <div className={styles.stepsLi}>
              <div className={styles.numberTwo}>2</div>

              <p className={styles.stepsText}>
                <span className={styles.stepsHeading}>
                  IF YOU&#39;RE SELECTED,
                </span>{' '}
                we&#39;ll ask you and other hosts to complete a
                couple activities!
              </p>
            </div>

            <div className={styles.cardMdContainer}>
              <Grid container justifyContent='flex-start'>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowRed]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={IconSurveyRed}
                        alt='Take a Survey'
                      />
                      <p className={styles.cardMdTitle}>Take a Survey</p>
                      <p className={styles.cardMdDesc}>5 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowRed]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={IconShareOnSocial}
                        alt='Share on Social'
                      />
                      <p className={styles.cardMdTitle}>Share on Social</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowRed]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% 0 10% 30%',
                          width: '50%',
                        }}
                        src={IconTakeSelfie}
                        alt='Take a Selfie'
                      />
                      <p className={styles.cardMdTitle}>Take a Selfie</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>

            <div className={styles.stepsLi}>
              <div className={styles.numberThree}>3</div>
              <p className={styles.stepsText}>
                <span className={styles.stepsHeading}>
                  AFTER YOU&#39;VE TRIED SVEDKA VODKA ON PARTY DAY,
                </span>{' '}
                we&#39;ll ask you to share your experience with us and with your
                friends and family.
              </p>
            </div>

            <div className={styles.cardMdContainer}>
              <Grid container justifyContent='flex-start'>
                <Grid key={1} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowOrange]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% auto 10%',
                          width: '50%',
                        }}
                        src={IconPostAPicture}
                        alt='Post a'
                      />
                      <p className={styles.cardMdTitle}>
                        Post a Picture
                      </p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={2} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowOrange]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '5% auto 10%',
                          width: '50%',
                        }}
                        src={IconPostOnInstagramOrange}
                        alt='Post on Instagram'
                      />
                      <p className={styles.cardMdTitle}>Post on Instagram</p>
                      <p className={styles.cardMdDesc}>1 min</p>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid key={3} lg={3} md={4} sm={6} xs={12} item>
                  <Card
                    className={[classes.cardMd, classes.cardMd__ShadowOrange]}
                  >
                    <CardContent className={classes.cardMdContent}>
                      <img
                        style={{
                          display: 'block',
                          margin: '0% 0 -15% 12%',
                          width: '80%',
                        }}
                        src={IconWriteAreview}
                        alt='Write a Review'
                      />
                      <p className={styles.cardMdTitle}>Write a Review</p>
                      <p className={styles.cardMdDesc}>5 min</p>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.applyNowContainer}>
        <Button size='small' variant='contained' color='success' className={styles.applyNowBtn} onClick={navigateToApplication}>Event Closed!</Button>
      </div>
      <div className={styles.footer} />
    </div>
  );
};

SvedkaHalloween.propTypes = {
  navigateToApplication: PropTypes.func.isRequired,
};

export default SvedkaHalloween;
